import { apiClient } from "./apiClient";

export interface OrderItem {
  productId: string;
  quantity: number;
  price: number;
  name: string;
  image?: string;
}

export interface Order {
  id: string;
  userId: string;
  items: OrderItem[];
  total?: number; // Optional for backward compatibility
  totalAmount?: number; // What backend actually sends
  status: "pending" | "processing" | "shipped" | "delivered" | "cancelled";
  shippingAddress: {
    name: string;
    address: string;
    city: string;
    state: string;
    zipCode: string;
    country: string;
  };
  customerName?: string; // What backend actually sends
  customerEmail?: string; // What backend actually sends
  paymentMethod?: string;
  paymentIntentId?: string; // What backend actually sends
  trackingUrl?: string; // Optional tracking URL
  trackingDetails?: string; // Optional tracking details
  createdAt: string;
  updatedAt?: string;
}

export interface CreateOrderData {
  items: OrderItem[];
  total: number;
  shippingAddress: {
    name: string;
    address: string;
    city: string;
    state: string;
    zipCode: string;
    country: string;
  };
  paymentMethod: string;
}

export const orderService = {
  createOrder: async (data: CreateOrderData): Promise<Order> => {
    return apiClient.post<Order>("/orders", data, true);
  },

  getAllOrders: async (): Promise<Order[]> => {
    return apiClient.get<Order[]>("/orders", true);
  },

  getUserOrders: async (): Promise<Order[]> => {
    return apiClient.get<Order[]>("/orders/user", true);
  },

  getOrder: async (id: string): Promise<Order> => {
    return apiClient.get<Order>(`/orders/${id}`, true);
  },

  updateOrderStatus: async (
    id: string,
    status: string,
    trackingUrl?: string,
    trackingDetails?: string
  ): Promise<Order> => {
    const payload: any = { status };
    if (trackingUrl !== undefined && trackingUrl !== null) {
      payload.trackingUrl = trackingUrl;
    }
    if (trackingDetails !== undefined && trackingDetails !== null) {
      payload.trackingDetails = trackingDetails;
    }

    return apiClient.put<Order>(`/orders/${id}`, payload, true);
  },

  // Cancel order (user can cancel their own orders)
  cancelOrder: async (id: string): Promise<Order> => {
    return apiClient.patch<Order>(`/orders/${id}/cancel`, {}, true);
  },
};
